import React from 'react';
import { storeShape } from '../../storeShape';

const convertTo12HrFormat = (hhmm) => {
  if (hhmm && hhmm.split(':').length && hhmm.split(':').length === 2) {
    const hoursStr = hhmm.split(':')[0];
    const minStr = hhmm.split(':')[1];

    const hoursInt = parseInt(hoursStr, 10);
    if (hoursInt === 0) {
      return `12${':'}${minStr}am`;
    }
    if (hoursInt < 12) {
      return `${hoursStr}${':'}${minStr}am`;
    }
    if (hoursInt === 12) {
      return `${hoursStr}${':'}${minStr}pm`;
    }

    const pmHoursString = (hoursInt - 12).toString();
    return `${pmHoursString}${':'}${minStr}pm`;
  }
  return hhmm;
};

/* Largely borrowed From StorePod */
export const StoreOverlayHours = ({ store }) => {
  const isDesignStore = store?.storeType === 'hddc';

  const {
    monday,
    tuesday,
    wednesday,
    thursday,
    friday,
    saturday,
    sunday
  } = store?.storeHours || {};

  const mon = { name: 'Monday', ...monday };
  const tue = { name: 'Tuesday', ...tuesday };
  const wed = { name: 'Wednesday', ...wednesday };
  const thu = { name: 'Thursday', ...thursday };
  const fri = { name: 'Friday', ...friday };
  const sat = { name: 'Saturday', ...saturday };
  const sun = { name: 'Sunday', ...sunday };

  let daysOfTheWeek = [mon, tue, wed, thu, fri, sat, sun];

  const normalDays = [];
  const irregularDays = [];

  daysOfTheWeek.slice(0, daysOfTheWeek.length - 1).forEach((day) => {
    const hasIrregularHours = day?.open && day?.close && (
      day?.open !== mon?.open || day?.close !== mon?.close
    );
    if (hasIrregularHours) {
      irregularDays.push(day);
    } else if (irregularDays.length === 0) {
      normalDays.push(day);
    } else {
      irregularDays.push(day);
    }
  });

  const getOpenCloseHours = (day) => {
    if (day?.open === day?.close) {
      return 'Closed';
    }
    return `${convertTo12HrFormat(day?.open)} - ${convertTo12HrFormat(day?.close)}`;
  };

  const getOpenCloseLabel = (day, day2) => {
    if (day2) {
      return `${day?.name.substring(0, 3)}-${day2?.name.substring(0, 3)}: `;
    }
    return `${day?.name.substring(0, 3)}: `;
  };

  const getOpenCloseBlock = (day, day2) => {
    return (
      <div key={day?.storeId}>
        <span className="sui-font-bold sui-block sui-capitalize">{getOpenCloseLabel(day, day2)}</span>
        {getOpenCloseHours(day)}
      </div>
    );
  };

  if (isDesignStore) return null;

  return (
    <div className="leading-6 sui-p-1" data-testid="store-overlay-hours">
      {normalDays.length === 1 && getOpenCloseBlock(mon)}
      {normalDays.length > 1 && getOpenCloseBlock((normalDays[0]), normalDays.slice(-1)[0])}
      {irregularDays.map((day) => getOpenCloseBlock(day))}
      {getOpenCloseBlock(sun)}
    </div>
  );
};

StoreOverlayHours.propTypes = {
  store: storeShape.isRequired
};

StoreOverlayHours.displayName = 'StoreOverlayHours';
